import React from 'react'
import { Link } from 'react-router-dom'
import './InfographicDesign.css'
// import Header from '../../Components/Header/Header'
// import Footer from '../../Components/Footer/Footer'
import GraphicAssistanceFAQ from '../Graphic-AA/Faq'
function InfographicDesign() {
  return (
    <div>
        {/* <Header/> */}
            <section className="infographic-hero d-flex align-items-center">
      <div className="container">
        <div className="row">
          {/* Text Section */}
          <div className="col-lg-6 col-md-12 text-section">
            <h1 className="hero-title">Infographic Design</h1>
            <p className="hero-description">
              Elevate your information presentation with our expert infographic
              design services. We create visually compelling infographics that
              simplify complex data, making it easily digestible and highly
              engaging. Our designs are tailored to captivate your audience,
              ensuring your key messages are conveyed clearly and effectively.
              Transform your data into stunning visual narratives that stand out
              and make an impact.
            </p>
            <div className="hero-buttons">
            <Link to={'/contactus'}><button className='btn btn-blue me-3'>Contact us</button></Link>
            <Link to={'/price'}><button className='btn btn-price'>See Pricing Plans</button></Link>
            </div>
          </div>
        </div>
      </div>
    </section>


    {/* infographic design workflow  design workflow */}
      <div className="design-workflow-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-md-6">
            <h6 className="subheading">Data-Driven and Engaging</h6>
            <h2 className="title">Visual Storytelling that Captivates and Informs</h2>
          </div>
          {/* Right Section */}
          <div className="col-md-6">
            <p className="description">
            Infographic design transforms complex data and information into visually appealing and easily digestible graphics. This service is essential for effectively communicating insights and trends to your audience, making it easier for them to understand and retain information. Infographics are perfect for reports, presentations, and social media, where clear and engaging visuals can significantly enhance the impact of your message.
            </p>
          </div>
        </div>
      </div>
    </div>


    {/* Infographic design and admin assistant service */}
    <div className="assistance-services-section">
      <div className="container">
        <h2 className="section-title text-center">Infographic Design Creative Services</h2>
        <div className="row text-center mt-5">
          {/* Service Card 1 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/iStock.webp" className="graphic-placeholder" alt="" />
              </div>
              <h5 className="service-title mt-3">Blog Graphics</h5>
              <p className="service-description">
              Perform thorough quality checks on your design projects with Media Dunes to ensure they meet the highest standards. Regular quality checks help maintain consistency and professionalism across all your designs.
              </p>
            </div>
          </div>

          {/* Service Card 2 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/quality.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">Data Visulisation</h5>
              <p className="service-description">
              Perform thorough quality checks on your design projects with Media Dunes to ensure they meet the highest standards. Regular quality checks help maintain consistency and professionalism across all your designs.
              </p>
            </div>
          </div>

          {/* Service Card 3 */}
          <div className="col-md-4">
            <div className="service-card">
              <div >
                <img src="/images/one3.webp" alt="" className="graphic-placeholder" />
              </div>
              <h5 className="service-title mt-3">One Page PDFs</h5>
              <p className="service-description">
              At Media Dunes, coordinate seamlessly between diverse design projects and team members to guarantee smooth workflows and timely delivery. Effective coordination streamlines your projects and enhances team collaboration.
              </p>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="text-center mt-4">
        <Link to={'/price'}><button className='btn btn-outline-primary'>See Pricing Plans</button></Link>
        </div>
      </div>
    </div>


{/* infographic-assisatance-service-para */}
<div className="assistance-service-container d-flex justify-content-center align-items-center">
      <div className="assistance-service-card p-4 ">
        <h5 className="text-uppercase text-light mb-3">Why Media Dunes</h5>
        <h2 className="text-white mb-3">
          What makes our Infographic Design Admin & Assistance service different?
        </h2>
        <p className="text-light">
          Our Infographic design admin and assistance services streamline your
          workflow by providing comprehensive support for all design tasks. From
          file management to quality checks and project coordination, our team
          ensures that your design projects are executed efficiently and to the
          highest standards, allowing you to focus on creativity.
        </p>
      </div>
    </div>
<GraphicAssistanceFAQ/>
{/* <Footer/> */}
    </div>
  )
}

export default InfographicDesign